module.exports = __webpack_public_path__ + "static/media/sf-test-8.c3fbd00a.mp3";